// extracted by mini-css-extract-plugin
export default {"container":"ClearChatButton_container__nhvLm","disabled":"ClearChatButton_disabled__fikxl"};